export const sections = [
  "Tax Adjustments",
  "Tax adjustment (separate sourced income)",
  "Tax adjustment (balancing charge)",
  "Further deduction s14n",
  "Further deduction other",
  "Current Year Capital Allowances",
  "Unutilised Capital Allowances",
  "Unutilised Losses",
  "Unutilised Donations",
  "Other Source Income",
  "Current Year Donations",
  "Current Year Investment Losses",
  "Partial Tax Exemption / Full Tax Exemption",
  "Corporate Income Tax Rebate",
  "Tax Previously Assessed",
];

export const autoload_sections = {
  "Tax Adjustments": "Tax Adjustments", // A
  "Tax adjustment (separate sourced income)":
    "Tax adjustment (separate sourced income)",
  "Tax adjustment (balancing charge)": "Tax adjustment (balancing charge)",
  "Further deduction s14n": "Further deduction s14n", // B
  "Further deduction other": "Further deduction other",
  "Other Source Income": "Other Source Income", // E
  "Current Year Capital Allowances": "Current Year Capital Allowances", // C
  "Current Year Donations": "Current Year Donations", // F
  "Current year Losses": "Unutilised Losses", // Note: same value as above
  "Tax deduction": "Tax Previously Assessed",
};

export const autoload_section_groups = [
  {
    label: "Tax Adjustments",
    options: [
      { label: "Tax Adjustments (general)", value: "Tax Adjustments" },
      {
        label: "Tax adjustment (separate sourced income)",
        value: "Tax adjustment (separate sourced income)",
      },
      {
        label: "Tax adjustment (balancing charge)",
        value: "Tax adjustment (balancing charge)",
      },
    ],
  },
  {
    label: "Further Deductions",
    options: [
      { label: "Further deduction s14n", value: "Further deduction s14n" },
      { label: "Further deduction other", value: "Further deduction other" },
    ],
  },
  {
    label: "Income",
    options: [{ label: "Other Source Income", value: "Other Source Income" }],
  },
  {
    label: "Unutilised Amounts",
    options: [
      {
        label: "Current Year Capital Allowances",
        value: "Current Year Capital Allowances",
      },
      { label: "Current Year Donations", value: "Current Year Donations" },
      { label: "Current year Losses", value: "Unutilised Losses" },
    ],
  },
  {
    label: "Tax Deductions",
    options: [
      { label: "Tax Previously Assessed", value: "Tax Previously Assessed" },
    ],
  },
];

export const autoload_sections_investment = {
  "Net Investment Income": "Net Investment Income",
  "Current Year Capital Allowances": "Current Year Capital Allowances",
  "Current Year Donations": "Current Year Donations",
  "Current Year Losses": "Current Year Investment Losses",
  "Tax deduction": "Tax Previously Assessed",
  "Common Expenses": "Allocation of Expenses/Common Expenses",
  "Statutory Expenses": "Allocation of Expenses/Statutory Expenses",
};

export const autoload_section_groups_investment = [
  {
    label: "Investment income",
    options: [
      { label: "Net Investment Income", value: "Net Investment Income" },
    ],
  },
  {
    label: "Expense allocation",
    options: [
      {
        label: "Common Expenses",
        value: "Allocation of Expenses/Common Expenses",
      },
      {
        label: "Statutory Expenses",
        value: "Allocation of Expenses/Statutory Expenses",
      },
    ],
  },
  {
    label: "Deductions and tax",
    options: [
      { label: "Current Year Donations", value: "Current Year Donations" },
      {
        label: "Current Year Capital Allowances",
        value: "Current Year Capital Allowances",
      },
      {
        label: "Current Year Losses",
        value: "Current Year Investment Losses",
      },
      { label: "Tax deduction", value: "Tax Previously Assessed" },
    ],
  },
];

export const savy_tax_adjustment_options = ["", "Added Back", "Deduct"];

export const pdf_title = {
  "Tax Adjustments": "Add/(Less): Tax Adjustments",
  "Tax adjustment (separate sourced income)":
    "Add/(Less): Tax adjustment - separate sourced income",
  "Tax adjustment (balancing charge)": "Add: Tax adjustment - balancing charge",
  "Further deduction s14n": "(Less): Further deduction s14n",
  "Further deduction other": "(Less): Further deduction other",
  "Other Source Income": "Add: Other sourced Income",
  "Current Year Capital Allowance": "(Less): Capital Allowances",
  "Prior Year Unutilised Amounts": "(Less): Unutilised Losses",
  "Current Year Donation": "(Less): Unutilised Donations",
  "Partial Tax Exemption (PTE) / PTE for Start-Ups":
    "(Less): Partial Tax Exemption",
  "Corporate Income Tax (CIT) Rebate": "(Less): Corporate Income Tax Rebate",
  "Tax Previously Assessed": "(Less): Tax Previously Assessed",
};
